import {StyledForm, FlexStartText, FormHeader} from '../../styled';
import {labels} from '../../translations';
import {BaseFormProps} from '../../types';
import Pills from './Pills';
import PositionMembersList from './PositionMembersList';
import {EmployeeNames, Position} from './types';
import {Translate} from '@planday-corp/globalization';
import Button from '@planday-corp/ui/actions/Button';
import {useState} from 'react';
import styled from 'styled-components';

const ScrollableWrapper = styled.div`
  overflow-y: auto;
  margin-bottom: -1rem;
`;

const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

interface TeamForm {
  positionsSetup: Record<Position['name'], EmployeeNames[]>;
}

export default function TeamForm({setStep}: Pick<BaseFormProps, 'setStep'>) {
  const [positions, setPositions] = useState<Position[]>([
    {name: 'Manager', isRemovable: false},
  ]);

  const handleNextStep = () => {
    setStep('portalCreationProgress');
  };

  const handleNewPositionAdded = (newPosition: string) => {
    setPositions([...positions, {name: newPosition, isRemovable: true}]);
  };

  const [positionSetup, setPositionSetup] = useState<
    Record<Position['name'], EmployeeNames[]>
  >({
    Manager: [{firstName: 'John', lastName: 'Doe'}],
  });

  const handlePositionMembersListChange = (
    position: string,
    employees: EmployeeNames[]
  ) => {
    setPositionSetup({...positionSetup, [position]: employees});
  };

  const handleRemovePosition = (positionName: string) =>
    setPositions(positions.filter(position => position.name !== positionName));

  return (
    <>
      <FormHeader>
        <FlexStartText size="title1" element="h1">
          {labels.teamStepTitle}
        </FlexStartText>
        <FlexStartText size="label">{labels.teamStepSubtitle}</FlexStartText>
      </FormHeader>
      <StyledForm>
        <Pills
          positions={positions}
          onPillClick={handleRemovePosition}
          onNewPositionAdded={handleNewPositionAdded}
        />
        <ScrollableWrapper>
          {positions.map(position => (
            <PositionMembersList
              key={position.name}
              position={position.name}
              onChange={handlePositionMembersListChange}
              assignedEmployees={positionSetup[position.name] || []}
            />
          ))}
        </ScrollableWrapper>
      </StyledForm>

      <StyledButtonWrapper>
        <Button name="next" type="primary" onClick={handleNextStep}>
          <Translate {...labels.teamStepNextButtonLabel} />
        </Button>
      </StyledButtonWrapper>
    </>
  );
}
